import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import {UpdateTitleDocumentPage} from "./update-title-document";

import { IonicSelectableModule } from 'ionic-selectable';

import { BrMaskerModule } from 'brmasker-ionic-3';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  declarations: [
    UpdateTitleDocumentPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateTitleDocumentPage),
    IonicSelectableModule,
    BrMaskerModule,
    FileUploadModule,
  ],
  exports: [
    UpdateTitleDocumentPage
  ]
})
export class UpdateTitleDocumentPageModule { }



// WEBPACK FOOTER //
// ./src/pages/update-title-document/update-title-document.module.ts